export const hexToRgb = (hex, opacity = 1) => {
    // 去除 '#' 符号
    const color = hex.replace('#', '');
    // 分割字符串并转换为数组
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
    return `RGB(${r}, ${g}, ${b}, ${opacity})`;
};
export const characterLen = (s) => {
    let result = 0;
    for (let i = 0; i < s.length; i++) {
        if (s.charCodeAt(i) > 255) {
            result += 2;
        }
        else {
            result++;
        }
    }
    return result;
};
